import { useState, useEffect } from "react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import Numeral from "numeral";

import { useCartContext } from "ab-context-cart";
import { useUserContext } from "ab-context-user";

import Text from "ab-text";
import Input from "ab-input";
import ABLink from "ab-link";
import Loading from "ook-loading";
import { gtmSendCheckoutStep0 } from "ab-gtm";

import CartInfoShipping from "./CartInfoShipping";
import CartItem from "./CartItem";

import "./ab-cart.scss";

const Cart = ({
  anadir,
  anadirProductos,
  cestaVacia,
  codigoDescuento,
  continuarComprando,
  descuento,
  eliminar,
  falloPago,
  finalizarCompra,
  intentarDeNuevo,
  introducirCodigo,
  iva,
  portes,
  portesQuedaX,
  titulo,
  failed,
  i18n,
}) => {
  const [state, dispatch] = useCartContext();
  const {
    appliedCoupons,
    contents,
    total,
    shippingTotal,
    shippingTax,
    totalTax,
    loaded,
    errorCoupon,
  } = state;
  const {
    applyCouponToCart,
    removeCouponFromCart,
    addItemsToCart,
    refreshCart,
  } = dispatch;
  const [stateUser, dispatchUser] = useUserContext();
  const { role } = stateUser;
  useEffect(() => {
    refreshCart();
  }, []);

  const [coupon, setCoupon] = useState("");
  const { t } = useTranslation("common", { i18n });

  if (Numeral.locales["abadia"] === undefined) {
    Numeral.register("locale", "abadia", {
      delimiters: {
        thousands: ".",
        decimal: ",",
      },
      abbreviations: {
        thousand: "k",
        million: "mm",
        billion: "b",
        trillion: "t",
      },
      ordinal: function (number) {
        var b = number % 10;
        return b === 1 || b === 3
          ? "er"
          : b === 2
            ? "do"
            : b === 7 || b === 0
              ? "mo"
              : b === 8
                ? "vo"
                : b === 9
                  ? "no"
                  : "to";
      },
      currency: {
        symbol: "€",
      },
    });
  }

  Numeral.locale("abadia");
  // console.log("Cart detail", totalTax);
  const totalForFreeShipping = role == "Personal" ? 50 : 100;

  return (
    <div className="ab-cart">
      {contents?.nodes?.length ? <Text element="h2">{titulo}</Text> : null}
      {contents?.nodes?.length && failed ? (
        <div className="row">
          <Text
            element="span"
            className="title"
            style={{ marginTop: 8, width: "100%", maxWidth: 590 }}
          >
            {falloPago}
          </Text>
          <Link prefetch={false} href={t("/finalizar-compra")}>
            <a
              onClick={() => {
                if (failed) {
                  addItemsToCart(state);
                }
              }}
            >
              {intentarDeNuevo}
            </a>
          </Link>
        </div>
      ) : null}
      {loaded && !contents?.nodes?.length ? (
        <div className="empty-cart">
          <Text element="h2">{cestaVacia}</Text>
          <Link prefetch={false} href={t("/tienda")}>
            <a>{continuarComprando}</a>
          </Link>
        </div>
      ) : loaded ? null : (
        <Loading loading />
      )}

      {(contents?.nodes?.length || 0) > 0 &&
        <CartInfoShipping language={i18n?.language} />
      }

      {contents?.nodes?.map((itm) => (
        <CartItem key={itm?.key} itm={itm} i18n={i18n} />
      ))}

      {contents?.nodes?.length ? (
        <div className="row coupon">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="1"
              y="1"
              width="20"
              height="20"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.83398 1.8335H20.1698V20.1677H1.83398V1.8335Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0333 18.4026C10.5741 18.9306 11.445 18.9242 11.9821 18.3843L12.644 17.7243C13.1573 17.2119 13.8668 16.9194 14.5901 16.9194H15.5342C16.2987 16.9194 16.9202 16.2979 16.9202 15.5344V14.5911C16.9202 13.8569 17.2044 13.1666 17.7232 12.6469L18.3832 11.9859C18.6518 11.7164 18.7957 11.3672 18.7948 10.9969C18.7939 10.6274 18.6481 10.28 18.3851 10.0179L17.7241 9.35602C17.2044 8.8326 16.9202 8.14327 16.9202 7.40902V6.4676C16.9202 5.7031 16.2987 5.0816 15.5342 5.0816H14.5919C13.8576 5.0816 13.1674 4.79652 12.6476 4.28043L11.9858 3.61768C11.4349 3.07227 10.5558 3.07502 10.0177 3.61677L9.35865 4.27768C8.83248 4.79743 8.14223 5.0816 7.41073 5.0816H6.46748C5.7039 5.08252 5.0824 5.70402 5.0824 6.4676V7.40718C5.0824 8.14143 4.79731 8.83168 4.28031 9.35235L3.62948 10.0041C3.62306 10.0114 3.61665 10.0169 3.61023 10.0234C3.07215 10.5651 3.0749 11.4442 3.61665 11.9823L4.27848 12.6441C4.79731 13.1648 5.0824 13.855 5.0824 14.5893V15.5344C5.0824 16.2979 5.70298 16.9194 6.46748 16.9194H7.4089C8.14406 16.9204 8.83431 17.2054 9.35406 17.7234L10.015 18.3824C10.0205 18.3889 10.0269 18.3953 10.0333 18.4026ZM10.9995 20.1681C10.2964 20.1681 9.59331 19.9023 9.05523 19.3688C9.0479 19.3614 9.04056 19.3541 9.03323 19.3459L8.3824 18.6959C8.12298 18.4384 7.77648 18.2954 7.40798 18.2944H6.46748C4.9449 18.2944 3.7074 17.056 3.7074 15.5344V14.5893C3.7074 14.2208 3.56348 13.8752 3.30498 13.6149L2.6459 12.9567C1.57523 11.8915 1.5624 10.1572 2.61381 9.07552C2.62206 9.06727 2.63031 9.05902 2.63856 9.05077L3.3059 8.3816C3.56348 8.12218 3.7074 7.77477 3.7074 7.40718V6.4676C3.7074 4.94593 4.9449 3.70752 6.46656 3.7066H7.41073C7.77831 3.7066 8.12481 3.56268 8.3879 3.30327L9.04331 2.64602C10.1149 1.5671 11.8666 1.5616 12.9474 2.63593L13.6175 3.30602C13.8769 3.5636 14.2234 3.7066 14.5919 3.7066H15.5342C17.0568 3.7066 18.2952 4.94502 18.2952 6.4676V7.40902C18.2952 7.7766 18.4382 8.12402 18.6976 8.38527L19.3558 9.04435C19.8774 9.56227 20.1671 10.2544 20.1698 10.9923C20.1726 11.7302 19.8875 12.4241 19.3677 12.9475L18.6958 13.6176C18.4382 13.877 18.2952 14.2226 18.2952 14.5911V15.5344C18.2952 17.056 17.0568 18.2944 15.5351 18.2944H14.5901C14.2271 18.2944 13.8723 18.4411 13.6147 18.6969L12.9566 19.355C12.4185 19.8968 11.709 20.1681 10.9995 20.1681Z"
                fill="#372F2F"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.6443 14.0446C8.4683 14.0446 8.2923 13.9777 8.15847 13.843C7.88989 13.5744 7.88989 13.1399 8.15847 12.8713L12.8701 8.15871C13.1387 7.89013 13.5741 7.89013 13.8427 8.15871C14.1113 8.4273 14.1113 8.86271 13.8427 9.1313L9.13014 13.843C8.9963 13.9777 8.8203 14.0446 8.6443 14.0446Z"
              fill="#372F2F"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.2963 14.2076C12.7893 14.2076 12.375 13.7979 12.375 13.2909C12.375 12.784 12.7811 12.3743 13.288 12.3743H13.2963C13.8032 12.3743 14.2129 12.784 14.2129 13.2909C14.2129 13.7979 13.8032 14.2076 13.2963 14.2076Z"
              fill="#372F2F"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.71227 9.62435C8.20535 9.62435 7.79102 9.2146 7.79102 8.70768C7.79102 8.20077 8.1971 7.79102 8.70402 7.79102H8.71227C9.21918 7.79102 9.62893 8.20077 9.62893 8.70768C9.62893 9.2146 9.21918 9.62435 8.71227 9.62435Z"
              fill="#372F2F"
            />
          </svg>

          <Text element="span" className="title">
            {codigoDescuento}
          </Text>

          <Input
            placeholder={introducirCodigo}
            value={appliedCoupons?.[0]?.code?.toUpperCase() || coupon}
            onChange={(val) => setCoupon(val)}
            error={errorCoupon == "error" ? t("cupon-no-encontrado") : ""}
            disabled={appliedCoupons}
          />

          <button
            disabled={!coupon}
            onClick={
              appliedCoupons
                ? () => {
                  removeCouponFromCart(appliedCoupons?.[0]?.code);
                  setCoupon("");
                }
                : () => applyCouponToCart(coupon)
            }
          >
            {appliedCoupons ? eliminar : anadir}
          </button>
        </div>
      ) : null}

      {appliedCoupons?.map((itm) => (
        <div className="row between">
          <Text element="span" className="title">
            {descuento}
          </Text>

          <Text element="span" className="title gold">
            {itm.code.toUpperCase()}
          </Text>

          <Text element="span" className="title">
            {`-${Numeral(
              Numeral(itm.discountAmount).value() +
              Numeral(itm.discountTax).value()
            ).format("1,000.00$")}`}
          </Text>
        </div>
      ))}

      {contents?.nodes?.length ? (
        <div className="row between">
          <Text element="span" className="title">
            {portes}
          </Text>

          {Numeral(shippingTotal).value() + Numeral(shippingTax).value() !=
            0 ? (
            <>
              <Text
                element="span"
                className="title gold"
              >{`${portesQuedaX?.replace(
                "${amount}",
                Numeral(totalForFreeShipping - Numeral(total).value()).format(
                  "1,000.00$"
                )
              )}`}</Text>
            </>
          ) : null}

          <Text element="span" className="title">
            {`${Numeral(
              Numeral(shippingTotal).value() + Numeral(shippingTax).value()
            ).format("1,000.00$")}`}
          </Text>
        </div>
      ) : null}

      {contents?.nodes?.length ? (
        <div className="total">
          <Text element="span" className="title">
            Total
          </Text>

          <Text element="h3">{Numeral(total).format("1,000.00$")}</Text>
          <Text element="span" className="title" style={{ width: "100%" }}>
            {iva?.replace("${amount}", Numeral(totalTax).format("1,000.00$"))}
          </Text>
          <Text element="span" className="title gold shipping-message">
            {t("envios-dentro-de-espana")}
          </Text>
        </div>
      ) : null}

      {contents?.nodes?.length > 0 ? (
        <div className="row">
          <ABLink text={anadirProductos} href={t("/tienda")} />

          <Link prefetch={false} href={t("/finalizar-compra")}>
            <a
              onClick={() => {
                gtmSendCheckoutStep0(state?.contents?.nodes);
                if (failed) {
                  addItemsToCart(state);
                }
              }}
            >
              {failed ? intentarDeNuevo : finalizarCompra}
            </a>
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default Cart;
